import { Component, NgZone, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '../settings.service';
import { UserFeedbackService } from '../user-feedback.service';
import { Subject, take, takeUntil } from 'rxjs';
import { NetworkConstants } from 'diwimamodelweb/lib';
import { getDoc, doc, collection, getDocs, query, where } from 'firebase/firestore';
import { Firestore } from '@angular/fire/firestore';
import { saveSelection } from '../utils/utils';
import { UserService } from '../user.service';

@Component({
  selector: 'app-super-context-settings-dialog',
  templateUrl: './super-context-settings-dialog.component.html',
  styleUrl: './super-context-settings-dialog.component.css'
})
export class SuperContextSettingsDialogComponent {
  private zone = inject(NgZone);
  private Ifirestore = inject(Firestore);

  form!: FormGroup
  contextId: string | null = null;
  loading = true;
  saving = false;
  allContexts: any[] = [];
  filteredContexts: any[] = [];
  contextFilterCtrl = new FormControl('', { nonNullable: true });
  rows: any[] = [];

  private user: any = null;
  private destroy$ = new Subject<void>();
  // private cdr = inject(ChangeDetectorRef);

  constructor(
    private dialogRef: MatDialogRef<SuperContextSettingsDialogComponent>,
    private fb: FormBuilder,
    private settingsService: SettingsService,
    private userFeedbackService: UserFeedbackService,
    private translateService: TranslateService,
    private userService: UserService
  ) {}


  ngOnInit(): void {
    this.userFeedbackService.loading.emit(true)

    this.contextId = this.settingsService.selectedUserContext$?.value?.identifier ?? null;
    const selectedIds = this.settingsService.selectedContextAndSubContextIds.value
    const IDS = this.settingsService.contextAndSubContextIds.value ?? []

    this.form = this.fb.group({
      contexts: [selectedIds ?? IDS]
    });


    this.settingsService.contextAndSubContextIds.subscribe( value => {
      this.load(value)
    })

    this.contextFilterCtrl.valueChanges.subscribe(() => this.applyContextFilter())

  }

  async load(ids) {
    try {
      const ctx = this.settingsService.selectedUserContext$.value
      const ctxs = ids.filter( c => c != ctx.identifier)
      const data = await this.loadContextsData(ctxs)
      const sorted = [...data].sort((a, b) => this.contextLabel(a).localeCompare(this.contextLabel(b)))
      this.allContexts = [{disabled:true, data:ctx}, ... sorted]
      this.applyContextFilter()
      this.loading = false
      this.userFeedbackService.loading.emit(false)
    } catch(error) {
      console.log(error)
      this.userFeedbackService.loading.emit(false)
    }

  }

  async loadContextsData(ids) {
    if (!ids.length) return [];

    return Promise.all(
      ids.map(async id => {
        const snap = await getDoc(doc(this.Ifirestore, NetworkConstants.COLLECTION_CONTEXT, id));
  
        return snap.exists()
          ? {disabled:false, data:{ identifier: snap.id, ...snap.data() }}
          : null;
      })
    );
  }

  async save() {

    const ids = this.form.value.contexts;
    this.settingsService.setSelectedContextAndSubContextIds([...ids])
    const ctx = this.settingsService.selectedUserContext$.value
    const user = await this.userService.user$.pipe(take(1)).toPromise() as any
    saveSelection(ctx?.identifier, ids, user?.identifier)
    this.dialogRef.close([true])

  }

  cancel(): void {
    this.dialogRef.close();
  }

  private contextLabel(co: any): string {
    const data = co?.data ?? {};
    return data.contextName ?? data.name ?? data.email ?? '';
  }

  private applyContextFilter(): void {
    const q = this.contextFilterCtrl.value.trim().toLowerCase();
    this.filteredContexts = q
      ? this.allContexts.filter(co => co.disabled || this.contextLabel(co).toLowerCase().includes(q))
      : this.allContexts;
  }

  onClosed(): void {
    this.contextFilterCtrl.setValue('');
  }



}
